module.exports = __webpack_public_path__ + "img/cross.32778bf5.svg";